import { render } from "./TaskLinkBlock.vue?vue&type=template&id=1fe47557&scoped=true&ts=true"
import script from "./TaskLinkBlock.vue?vue&type=script&lang=ts"
export * from "./TaskLinkBlock.vue?vue&type=script&lang=ts"

import "./TaskLinkBlock.vue?vue&type=style&index=0&id=1fe47557&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fe47557"]])

export default __exports__